declare global {
  interface Window {
    dataLayer: unknown[]
  }
}

export function ensureDataLayer() {
  window.dataLayer = window.dataLayer || []
}

export function initConsentDefault() {
  ensureDataLayer()
  window.dataLayer.push([
    'consent',
    'default',
    {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      wait_for_update: 500,
    },
  ])
}

export function updateConsent(granted: boolean) {
  ensureDataLayer()
  const state = granted ? 'granted' : 'denied'
  window.dataLayer.push([
    'consent',
    'update',
    {
      ad_storage: state,
      analytics_storage: state,
      ad_user_data: state,
      ad_personalization: state,
    },
  ])
}
